import { useState } from 'react';
import { evaluate } from 'mathjs';
import './App.css';

function App() {
  const [input, setInput] = useState('');

  const handleClick = (value) => {
    setInput((prev) => prev + value);
  };

  const handleClear = () => {
    setInput('');
  };

  const handleEqual = () => {
    try {
      try {
        const result = evaluate(input);
        setInput(result.toString());
      } catch {
        setInput("Error");
      }
    } catch (error) {
      setInput('Error');
    }
  };

  const buttons = [
    '7', '8', '9', '/',
    '4', '5', '6', '*',
    '1', '2', '3', '-',
    '0', '.', '=', '+',
  ];

  return (
    <div className="calculator-container">
      <div className="calculator">
        <input
          type="text"
          value={input}
          readOnly
          className="calculator-display"
        />
        <div className="calculator-buttons">
          {buttons.map((btn, idx) => (
            <button
              key={idx}
              onClick={
                btn === '=' ? handleEqual
                : btn === 'C' ? handleClear
                : () => handleClick(btn)
              }
              className={btn === '=' ? 'equals' : ''}
            >
              {btn}
            </button>
          ))}
          <button onClick={handleClear} className="clear">C</button>
        </div>
      </div>
    </div>
  );
}

export default App;
